/**
 * KAN-754: кнопки владельца в шапке каталога: "Добавить товар" и
 * "Добавить категорию" с их диалогами. Новый товар и подкатегория по
 * умолчанию попадают в открытую категорию.
 */
import { useState } from 'react';
import { FolderPlus, Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { CategoryFormDialog } from './CategoryFormDialog';
import { ProductFormDialog } from './ProductFormDialog';

interface Props {
  /** Открытая в каталоге категория. */
  categoryId: string | null;
}

export function CatalogOwnerActions({ categoryId }: Props) {
  const [productOpen, setProductOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);

  return (
    <div className="flex flex-wrap gap-2">
      <Button size="sm" variant="outline" onClick={() => setCategoryOpen(true)}>
        <FolderPlus className="mr-1.5 h-4 w-4" />
        Добавить категорию
      </Button>
      <Button size="sm" onClick={() => setProductOpen(true)}>
        <Plus className="mr-1.5 h-4 w-4" />
        Добавить товар
      </Button>
      <ProductFormDialog open={productOpen} onOpenChange={setProductOpen} defaultCategoryId={categoryId} />
      <CategoryFormDialog open={categoryOpen} onOpenChange={setCategoryOpen} defaultParentId={categoryId} />
    </div>
  );
}
